/**
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'./VIPRDataRequestHandler'
], function(_, VIPRHandler) {

	const VIPRCachedHandler = VIPRHandler.extend({

		init: function(options) {
			VIPRCachedHandler.inherited('init', this, arguments);
			this.handler = options.handler;
		},

		// Implement IDataRequestHandler
		request: function(_request) {

			if (!this.handler) {
				return VIPRCachedHandler.inherited('request', this, arguments);
			}

			const data = this.handler.getLastRequestData(_request.name);
			if (data) {
				let dataCopy = _.clone(data);
				this._requestComplete(_request, dataCopy);
			} else {
				return VIPRCachedHandler.inherited('request', this, arguments);
			}
		},

		_requestComplete: function(_request, data) {
			const shouldCache = false;
			return VIPRCachedHandler.inherited('_requestComplete', this, [ _request, data, shouldCache ]);
		},

		_requestFail: function(_request, data) {
			const shouldCache = false;
			return VIPRCachedHandler.inherited('_requestFail', this, [ _request, data, shouldCache ]);
		},

		_invokeCallback: function(/* name, data */) {}

	});

	return VIPRCachedHandler;
});
